import(/* webpackMode: "eager" */ "/home/iktravels/domains/website/src/app/faq/page.tsx");
